import ucenterHttp from '@core/ucenterHttp';
import config from '@config';

// 查询用户认证信息（已通过 或 已驳回，获取认证信息的结果）
export const getMemberAuthInfoApi = params => {
    return ucenterHttp.get(`${config.UCENTER_PREFIX}/wapi/member6/findMemInfoByMemcards`, params);
};
